// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ce_S","location":"Header_location__1Y4Jy"};